import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/modules/Landing/pages/HomeView.vue'),
    meta: {
      title: "cvLab — CV va Resume Builder | O'zbekiston",
      description: "Professional CV va rezyumeni daqiqada yarating. Zamonaviy shablonlar, real-time preview, PDF eksport. Mutlaqo bepul.",
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/modules/Landing/pages/PrivacyPolicy.vue'),
    meta: {
      title: "Maxfiylik siyosati — cvLab",
      description: "cvLab platformasining shaxsiy ma'lumotlar bilan ishlash qoidalari himoyasi.",
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/modules/Landing/pages/TermsOfService.vue'),
    meta: {
      title: "Ommaviy Oferta — cvLab",
      description: "Foydalanish qoidalari va xizmat shartnomasi (Ommaviy Oferta).",
    },
  },
]

export default routes
